// extracted by mini-css-extract-plugin
export default {"controlPanelLabel":"SetSelector_controlPanelLabel__iqJyT","setSelection":"SetSelector_setSelection__LPAwO","setSelect":"SetSelector_setSelect__rndK1"};